import React from 'react';
import dayjs from 'dayjs'

export default class Card extends React.Component {
    goTo() {
        const { contest, history } = this.props;
        window.scrollTo(0, 0);
        history.push(`/contests/${contest._id}`);
    }

    render() {
        const { contest, expired } = this.props;
        const featureImg = Boolean(contest.featuredImage) ? contest.featuredImage : 'https://images.unsplash.com/photo-1556761175-4b46a572b786?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1334&q=80';
        return (
            <div onClick={() => this.goTo()} className="cursor-pointer mx-auto lg:m-0 max-w-sm w-full sm:w-1/2 lg:w-1/3 py-6 px-3">
                <div className="bg-white shadow-xl rounded-lg overflow-hidden">
                    <div className="relative bg-cover bg-center h-56 p-4" style={{ backgroundImage: `url(${featureImg})` }}>
                        <div className="bg-gradient-black-to-transparent"></div>
                    </div>
                    <div className="p-4">
                        <p className="text-2xl text-gray-900 truncate">{contest.name}</p>
                        <p className="text-gray-700 truncate">{contest.content}</p>
                    </div>
                    <div className="px-4 pt-3 pb-4 border-t border-gray-300 bg-gray-100">
                        <div className="flex items-center pt-2">
                            <div>
                                <p className="font-bold text-gray-900">{}</p>
                                <p className="text-sm font-semibold text-gray-700">Contest {expired ? 'ended' : 'ends'} on {dayjs(contest.expires).format('MMM DD, YYYY')}</p>
                                <p className="text-sm text-gray-700">{contest.entries.length} {contest.entries.length === 1 ? 'entry' : 'entries'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contests/card.js